import { useReferenceData } from '@/contexts/reference-data-context';
import type { ReferenceState } from '@/api/api.schemas';
import { Select, SelectProps } from '../inputs/select';
import { formatState } from '@/util/helpers';

interface StateSelectorProps extends Omit<SelectProps, 'options'> {
  states?: ReferenceState[];
}

export function StateSelector({
  states,
  placeholder,
  className,
  ...restProps
}: StateSelectorProps) {
  const { data: referenceData } = useReferenceData();
  const stateList = states ?? referenceData.states;

  // We change the key of the component when the states are loaded.
  // This prevents a race condition where the Select would initially render with an
  // empty `options` array, causing react-hook-form's `defaultValue` to fail.
  return (
    <Select
      {...restProps}
      key={stateList.map((state) => state.abbreviation).join(',')}
      className={className}
      placeholder={placeholder}
      options={stateList.map((state) => ({
        value: state.abbreviation,
        label: formatState(state),
      }))}
    />
  );
}
